import { download } from "./download";

/**
 * @deprecated Use the CSVDocument to build the document
 *             and the `save` method to output it to a file
 */
export const saveCsvFile = (csv: string, filename: string) => {
	download(csv, filename, "text/csv");
};

export class CSVDocument {
	#rows: string[][] = [];

	add(...rows: string[][]) {
		this.#rows.push(...rows);
	}

	serialize(): string {
		const lines: string[] = [];

		for (const row of this.#rows) {
			lines.push(row.map((val) => this.#escape(val)).join(","));
		}

		return lines.join("\r\n");
	}

	save(fname: string) {
		const csv = this.serialize();

		download(csv, fname, "text/csv");
	}

	#escape(value: string): string {
		if (/[",\n]/.test(value)) {
			const escaped = value.replace(/"/g, '""');
			return `"${escaped}"`;
		}

		return value;
	}
}
